import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';
import { horizontalScrollTabs } from '@alfa-bank/site-helpers-common/scroll/horizontal-scroll-tabs';

import { useAnchorValue } from './use-anchor-value';

export const useFirstHorizontalScroll = (wrapperRef: RefObject<HTMLDivElement>) => {
    const selectedTabRef = useRef<HTMLButtonElement>(null);
    const anchorValue = useAnchorValue();

    useEffect(() => {
        if (anchorValue === null) return;

        // Отменяем кастомный скролл, если URL содержит #hash
        if (selectedTabRef.current && !anchorValue) {
            horizontalScrollTabs(wrapperRef)({
                currentTarget: selectedTabRef.current,
            });
        }
    }, [anchorValue, wrapperRef]);

    return selectedTabRef;
};
